export const LAST_ACTIVITY_STORAGE_KEY = "orgAdminLastActivityAt";
export const INACTIVITY_LOGOUT_FLAG = "inactivityLogout";
export const INACTIVITY_LOGOUT_MESSAGE =
  "You have been logged out due to inactivity. Please log in again.";

export const ACTIVITY_EVENTS = [
  "mousemove",
  "mousedown",
  "keydown",
  "scroll",
  "touchstart",
  "click",
];

export const getInactivityPhase = (lastActivityAt, now, timeoutMs, warningMs) => {
  const elapsed = now - lastActivityAt;
  if (elapsed >= timeoutMs + warningMs) {
    return "expired";
  }
  if (elapsed >= timeoutMs) {
    return "warning";
  }
  return "active";
};

export const getMsUntilNextPhase = (lastActivityAt, now, timeoutMs, warningMs) => {
  const phase = getInactivityPhase(lastActivityAt, now, timeoutMs, warningMs);
  if (phase === "expired") {
    return 0;
  }
  if (phase === "warning") {
    return Math.max(0, lastActivityAt + timeoutMs + warningMs - now);
  }
  return Math.max(0, lastActivityAt + timeoutMs - now);
};

export const formatWarningCountdown = (remainingMs) => {
  const totalSeconds = Math.max(0, Math.ceil(remainingMs / 1000));
  if (totalSeconds >= 60) {
    const minutes = Math.ceil(totalSeconds / 60);
    return `You will be automatically logged out in ${minutes} minute${
      minutes === 1 ? "" : "s"
    }.`;
  }
  return `You will be automatically logged out in ${totalSeconds} second${
    totalSeconds === 1 ? "" : "s"
  }.`;
};
